import { getPatternClockAPI } from "@/apis/usage-api"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { create } from "zustand"

export const clockStore = create((set) => ({
  unit: "m³",
  datasets: null,
  peak: null,

  apiGetPatternClock: async ({ dong, ho, resource }) => {
    const { sido, kapt_code, ended_at: target_date } = aptSearchStore.getState().pickApt
    const { unit, datasets, peak } = await getPatternClockAPI({
      sido,
      kapt_code,
      dong,
      ho,
      target_date,
      resource
    })
    set({ unit, datasets, peak })
  },

  reset: () => {
    set({
      unit: "m³",
      datasets: null,
      peak: null
    })
  }
}))
